import type { SupWeb3Address } from "@/types";
import type { BigNumberish } from "@ethersproject/bignumber";
import { useMemo } from "react";

import useApi from "@/hooks/api/useApi";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";

export interface PiggyHarvestStartResponse {
  transactionData: SupWeb3Address;
  to: SupWeb3Address;
  value: BigNumberish;
  gasPriceInGwei: number;
}

/**
 * Hook to start harvest operation
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/30355904-9778d7d4-f93e-4cce-a394-dfc724c2e972?action=share&source=copy-link&creator=26633220&active-environment=9faa12dd-452a-4b02-81a7-eced0431d716
 */
export default function usePiggyHarvestStart(enabled: boolean = true, approvalRequired: boolean = false) {
  const userAddress = useWeb3UserAddress();

  const { path, params } = useMemo(
    () => ({
      path: `/token-distribution/slop-bucket/start/harvest/${userAddress}/`,
      params: {
        approval_required: approvalRequired,
      },
    }),
    [approvalRequired, userAddress]
  );

  const { data, isLoading, isError, error, mutate } = useApi<PiggyHarvestStartResponse, PiggyHarvestStartResponse>(
    {
      path,
      params,
      api: "v2",
    },
    {
      enabled: !!userAddress && enabled,
      strategy: "fully-cached",
    }
  );

  return {
    data,
    isLoading,
    isError,
    error,
    mutate,
  };
}
